import { css } from "styled-components";

export const fontColorSelector = ({ color }: { color: string }) => {
  switch (color) {
    case "weak":
      return css`
        color: ${({ theme }) => theme?.colors?.neutral.neutral70};
      `;

    case "primary":
      return css`
        color: ${({ theme }) => theme?.colors?.neutral.neutral90};
      `;

    case "titles":
      return css`
        color: ${({ theme }) => theme?.colors?.neutral.neutral80};
      `;

    case "primary-web":
      return css`
        color: ${({ theme }) => theme?.colors?.primary.default};
      `;

    case "primary-web-hover":
      return css`
        color: ${({ theme }) => theme?.colors?.primary.hover};
      `;

    case "primary-web-pressed":
      return css`
        color: ${({ theme }) => theme?.colors?.primary.pressed};
      `;

    case "secondary-web":
      return css`
        color: ${({ theme }) => theme?.colors?.secondary.default};
      `;

    case "danger":
      return css`
        color: ${({ theme }) => theme?.colors?.danger.default};
      `;

    case "success":
      return css`
        color: ${({ theme }) => theme?.colors?.success.main};
      `;

    case "white":
      return css`
        color: ${({ theme }) => theme?.colors?.white};
      `;

    case "neutral100":
      return css`
        color: ${({ theme }) => theme?.colors?.neutral.neutral100};
      `;

    case "warning":
      return css`
        color: ${({ theme }) => theme?.colors?.warningv2.main};
      `;

    case "neutral90":
      return css`
        color: ${({ theme }) => theme?.colors?.neutral.neutral90};
      `;

    case "neutral80":
      return css`
        color: ${({ theme }) => theme?.colors?.neutral.neutral80};
      `;

    case "neutral70":
      return css`
        color: ${({ theme }) => theme?.colors?.neutral.neutral70};
      `;

    case "neutral60":
      return css`
        color: ${({ theme }) => theme?.colors?.neutral.neutral60};
      `;

    case "neutral40":
      return css`
        color: ${({ theme }) => theme?.colors?.neutral.neutral40};
      `;

    case "neutral30":
      return css`
        color: ${({ theme }) => theme?.colors?.neutral.neutral30};
      `;

    case "neutral20":
      return css`
        color: ${({ theme }) => theme?.colors?.neutral.neutral20};
      `;

    case "neutral10":
      return css`
        color: ${({ theme }) => theme?.colors?.neutral.neutral10};
      `;

    case "disabled":
      return css`
        color: ${({ theme }) => theme?.colors?.typography.disabled};
      `;

    case "link":
      return css`
        color: ${({ theme }) => theme?.colors?.typography.link};
      `;

    case "secondary-pressed":
      return css`
        color: ${({ theme }) => theme?.colors?.secondary.pressed};
      `;

    default:
      return css`
        color: ${({ theme }) => color ?? theme?.colors?.neutral.neutral90};
      `;
  }
};

export const backgroundColorSelector = ({ background }: any) => {
  switch (background) {
    case "primary":
      return css`
        background-color: ${({ theme }) => theme?.colors?.primary.default};
      `;

    case "secondary-thin":
      return css`
        background-color: ${({ theme }) => theme?.colors?.secondary.surface};
      `;

    case "gray":
      return css`
        background-color: ${({ theme }) => theme?.colors?.gray1};
      `;

    default:
      return css`
        background-color: ${({ theme }) => background || theme?.colors?.white};
      `;
  }
};
